var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"modal-button",attrs:{"data-enable-pointer-events":"true"},on:{"click":function($event){_vm.$store.dispatch('sequences_store/endAllSequences'); _vm.$router.push({name: 'Main'})}}},[_vm._v(" В аппаратную ")])}
var staticRenderFns = []

export { render, staticRenderFns }